import $ from 'jquery';
import {deviceIsMinMd} from '../../js/utilities/media-queries.mjs';

const CSS_CLASS_ANIMATED = '-animated';
const CSS_CLASS_POP_IN = '-pop-in';
const CSS_CLASS_REVEAL = '-reveal';
const SELECTOR_LIST = '.ef-map-interactive__list';

const $component = $('#ef-map-interactive');
const $buttonsInteraction = $component.find('.ef-map-interactive__map-interaction');
const $buttonsChangeMap = $('[data-toggle="map"]');
const $maps = $('.ef-map-interactive__map');
const $lists = $(SELECTOR_LIST);


placeInteractiveButtons(deviceIsMinMd, $buttonsInteraction);
deviceIsMinMd.addListener(placeInteractiveButtons.bind(null, deviceIsMinMd, $buttonsInteraction));

$buttonsChangeMap.on('click', handleMapSwitch);

/**
 * @param {MediaQueryList} deviceIsMinMdMql
 * @param {Object} $buttonsInteraction jQuery Node of interactive buttons
 */
function placeInteractiveButtons(deviceIsMinMdMql, $buttonsInteraction) {
  $buttonsInteraction.each((index, button) => {
    const $button = $(button);
    const buttonPosition = $button.data('position') || false;

    if (!buttonPosition) {
      // Do nothing
      return;
    }

    const viewport = deviceIsMinMdMql.matches ? 'desktop' : 'mobile';

    // Hide
    $button.removeClass(CSS_CLASS_POP_IN).addClass(CSS_CLASS_ANIMATED);

    // Place
    $button.css({
      top: buttonPosition[viewport].y,
      left: buttonPosition[viewport].x,
    });

    // Show
    setTimeout(() => {
      $button.addClass(CSS_CLASS_POP_IN);
    }, index * 100);
  });
}

/**
 * @param {Event} event
 */
function handleMapSwitch(event) {
  const $button = $(event.delegateTarget);
  const $targetMap = $($button.data('target'));
  const $targetList = $targetMap.next(SELECTOR_LIST);
  const $targetMapButtons = $targetMap.find($buttonsChangeMap);

  // Preparations
  $component.css('height', $component.height()); // Prevent collapse of content
  $targetMapButtons.prop('disabled', true); // Prevents to fast following switch

  // Switch
  $maps.fadeOut(250, () => {
    // Cleanup
    $maps.find('[data-toggle]').removeClass(CSS_CLASS_POP_IN).addClass(CSS_CLASS_ANIMATED);
  });
  $targetMap.delay(300).fadeIn(500, () => {
    // Direct screen readers to the next place
    $targetMap.children('h3').focus();

    // Pop-in buttons
    $targetMap.find('.' + CSS_CLASS_ANIMATED).each((index, button) => {
      setTimeout(() => {
        const $button = $(button);
        $button.addClass(CSS_CLASS_POP_IN)
        setTimeout(() => {
          // Cleanup animation classes to prevent conflict with hover transformation
          $button.removeClass(CSS_CLASS_POP_IN).removeClass(CSS_CLASS_ANIMATED);
        }, 300);
      }, index * 100);
    });
    $targetMapButtons.prop('disabled', false);
  });
  $lists.fadeOut(250);
  $targetList.delay(300).fadeIn(500, () => {
    // Cleanup
    $component.css('height', '');
    $lists.find('li').removeClass(CSS_CLASS_REVEAL).addClass(CSS_CLASS_ANIMATED);

    // Reveal list items
    $targetList.find('.' + CSS_CLASS_ANIMATED).each((index, button) => {
      setTimeout(() => {
        $(button).addClass(CSS_CLASS_REVEAL);
      }, index * 300);
    });
  });
}
